// src/api/index.js
import api, { API_BASE_URL, getImageUrl } from "./axios";

// Re-export axios client and base helpers
export { api, API_BASE_URL, getImageUrl };

// ==========================================
// 1. AUTHENTICATION APIS
// ==========================================
export const authApi = {
  login: (username, password) => api.post("/auth/login", { username, password }),
  signup: (email) => api.post("/auth/signup", { email }),
  verifyCode: (username, code) => api.post("/auth/verify-code", { username, code }),
};

// ==========================================
// 2. ABOUT CHAPTER APIS
// ==========================================
export const aboutChapterApi = {
  get: () => api.get("/about-chapter"),
  update: (formData) =>
    api.post("/about-chapter", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

// ==========================================
// 3. ANNOUNCEMENTS APIS
// ==========================================
export const announcementsApi = {
  getAll: () => api.get("/announcements"),
  getById: (id) => api.get(`/announcements/${id}`),
  create: (formData) => api.post("/announcements", formData),
  update: (id, formData) => api.put(`/announcements/${id}`, formData),
  delete: (id) => api.delete(`/announcements/${id}`),
};

// ==========================================
// 4. BENEFITS APIS
// ==========================================
export const benefitsApi = {
  getAll: () => api.get("/benefits"),
  create: (formData) => api.post("/benefits", formData),
  delete: (id) => api.delete(`/benefits/${id}`),
};

// ==========================================
// 5. BLOGS APIS
// ==========================================
export const blogsApi = {
  getAll: () => api.get("/blogs"),
  create: (formData) => api.post("/blogs", formData),
  delete: (id) => api.delete(`/blogs/${id}`),
};

// ==========================================
// 6. CALENDAR APIS
// ==========================================
export const calendarApi = {
  getAll: () => api.get("/calendar"),
  create: (formData) => api.post("/calendar", formData),
  delete: (id) => api.delete(`/calendar/${id}`),
};

// ==========================================
// 7. CONTACT INFO / PHONE APIS
// ==========================================
export const contactInfoApi = {
  get: () => api.get("/contactinfo"),
  update: (phone) => api.post("/contactinfo", { phone: phone ? phone.trim() : "" }),
};

// ==========================================
// 8. EVENTS APIS
// ==========================================
export const eventsApi = {
  getAll: () => api.get("/events"),
  createYear: (label) => api.post("/events/year", { label }),
  deleteYear: (id) => api.delete(`/events/year/${id}`),
  createEvent: (formData) =>
    api.post("/events", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteEvent: (id) => api.delete(`/events/${id}`),
};

// ==========================================
// 9. GALLERY APIS
// ==========================================
export const galleryApi = {
  getAll: () => api.get("/gallery"),
  upload: (formData) => api.post("/gallery", formData),
  delete: (id) => api.delete(`/gallery/${id}`),
};

// ==========================================
// 10. HOME IMAGES APIS
// ==========================================
export const homeImagesApi = {
  getAll: () => api.get("/home-images"),
  upload: (formData) => api.post("/home-images", formData),
  delete: (id) => api.delete(`/home-images/${id}`),
};

// ==========================================
// 11. JOIN LINK APIS
// ==========================================
export const joinLinkApi = {
  get: () => api.get("/join-link"),
  update: (link) => api.post("/join-link", { link }),
};

// ==========================================
// 12. OUR TEAM APIS
// ==========================================
export const ourTeamApi = {
  getAll: () => api.get("/ourteam"),
  createYear: (label) => api.post("/ourteam/year", { label }),
  deleteYear: (id) => api.delete(`/ourteam/year/${id}`),
  createMember: (formData) => api.post("/ourteam/member", formData),
  deleteMember: (id) => api.delete(`/ourteam/member/${id}`),
};

// ==========================================
// 13. TEAM (LEGACY / HOME TEAM) APIS
// ==========================================
export const teamApi = {
  getAll: () => api.get("/team"),
  create: (formData) => api.post("/team", formData),
  delete: (id) => api.delete(`/team/${id}`),
};

// ==========================================
// 14. POPUP APIS
// ==========================================
export const popupApi = {
  get: () => api.get("/popup"),
  upload: (formData) => api.post("/popup", formData),
  delete: () => api.delete("/popup"),
};

export default api;
